import { loggerService } from "./logger-service";

class ScriptLoaderService {
  private loadedScripts = new Map<string, Promise<any>>();

  loadScript(
    url: string,
    options: Partial<{
      async: boolean;
      defer: boolean;
      oneTrustIgnore: boolean;
      class: string;
    }> = { async: true }
  ): Promise<any> {
    let result = this.loadedScripts.get(url);
    if (!result) {
      const startTime = performance.now();

      result = new Promise<any>((resolve, reject) => {
        const s = document.createElement("script");

        s.onerror = () =>
          handleScriptLoadingFailure("error event", "Failed to load script");

        s.onabort = () =>
          handleScriptLoadingFailure("abort event", "Script loading aborted");

        s.onload = resolve;

        s.type = "text/javascript";
        s.async = Boolean(options.async); // set to true by default
        s.defer = Boolean(options.defer);

        // prevent onetrust blocking script
        if (options.oneTrustIgnore) {
          s.setAttributeNode(document.createAttribute("data-ot-ignore"));
        }

        if (options.class) {
          s.setAttribute("class", options.class);
        }

        s.src = url;
        document.getElementsByTagName("head")[0].appendChild(s);

        const handleScriptLoadingFailure = (
          errorType: string,
          errorMessage: string
        ): void => {
          const loadTime = Math.round(performance.now() - startTime);
          loggerService.logError(errorMessage, {
            errorType,
            loadTimeMs: loadTime,
          });
          this.loadedScripts.delete(url);
          reject(`${errorMessage}: ${url}`);
        };
      });

      this.loadedScripts.set(url, result);
    }

    return result;
  }
}

export const scriptLoader = new ScriptLoaderService();
